export default __webpack_public_path__ + "static/media/pic14.ef70eda3.jpg";